import { useQueryClient } from '@tanstack/react-query';
import { useSite } from '../../../../context/page-context';
import { useOptimisticMutation, type Variables } from '../../../../hooks/use-optimistic-mutation';
import { useAccountApi } from '../../hooks/use-settings-api';
import type { TeamApiResponse, TeamInviteApiResponse } from '../../types';
import { QK_ACCOUNT_TEAM } from './use-account-team';

export function useDeleteTeamInvite() {
  const { accountApi } = useAccountApi();
  const { teamId } = useSite();
  const queryClient = useQueryClient();

  async function deleteInvite(id: number) {
    await accountApi.team(teamId).deleteInvite(id);
  }

  return useOptimisticMutation<TeamApiResponse, Variables<typeof deleteInvite>>({
    queryClient,
    queryKey: QK_ACCOUNT_TEAM(teamId),
    mutationFn: deleteInvite,
    optimisticUpdate: (prev, id) => {
      if (!prev) {
        return prev;
      }

      return {
        ...prev,
        invites: prev.invites.filter((invite: TeamInviteApiResponse) => invite.id !== id),
      };
    },
  });
}
